import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { Container, Row, Col } from "react-bootstrap";
import api from "../../services/api";
import Template from "../../template";
import * as S from "./styled";
import { useAuth } from "../../context/auth";
import GraficoLinhas from "./GraficoLinhas";
import GraficoLinhas2 from "./GraficoLinhas2";

// O grafico que está sendo usado atualmente é o GraficoLinhas.jsx e GraficoLinhas2.jsx


function Medias(props) {
  const uerjReqRef = useRef(0);

  const date1 = new Date();

  const { user } = useAuth();

  const [uerjLoading, setUerjLoading] = useState(false);
  const [uerjCheckedAlunoId, setUerjCheckedAlunoId] = useState(null);

  const IA_PAID_PLANS = new Set(["ESSENCIAL", "PLUS", "VIP", "PREMIUM"]);
  const isOnlinePaidPlan = IA_PAID_PLANS.has(user?.plano);

  const [mediaUerj, setMediaUerj] = useState(null);
  const [idAluno, setIdAluno] = useState(user.id);

  const isAdmin = user?.nivel === "a";
  const isViewingOwnProfile = String(idAluno) === String(user?.id);

  const hasUerj = mediaUerj !== null;
  const uerjChecked = String(uerjCheckedAlunoId) === String(idAluno);
  const uerjChecking = !uerjChecked || uerjLoading;

  // admin vê sempre no próprio perfil.
  // para outros alunos, só mostra se tiver dados.
  // usuário comum: depende do plano + existência de dados.
  const showUerjButton = isAdmin
    ? (isViewingOwnProfile || hasUerj || uerjChecking)
    : (!isOnlinePaidPlan && (hasUerj || uerjChecking));

  const [mes, setMes] = useState(date1.getMonth() + 1);
  const [ano, setAno] = useState(date1.getFullYear());
  const [loading, setLoading] = useState(true);
  const [calculandoMedia, setCalculandoMedia] = useState(false);
  const [media, setMedia] = useState([]);
  const [medias, setMedias] = useState([]);

  // Novos estados para períodos disponíveis
  const [periodosDisponiveis, setPeriodosDisponiveis] = useState([]);
  const [periodosSelecionados, setPeriodosSelecionados] = useState([]);
  const [loadingPeriodos, setLoadingPeriodos] = useState(false);
  const [hoveredPeriodo, setHoveredPeriodo] = useState(null);

  const [pessoa, setPessoa] = useState(user.nome);

  const [media1, setMedia1] = useState(0);
  const [media2, setMedia2] = useState(0);
  const [media3, setMedia3] = useState(0);
  const [media4, setMedia4] = useState(0);
  const [media5, setMedia5] = useState(0);
  const [media6, setMedia6] = useState(0);
  const [media11, setMedia11] = useState(0);
  const [media12, setMedia12] = useState(0);
  const [media13, setMedia13] = useState(0);
  const [media14, setMedia14] = useState(0);
  const [media15, setMedia15] = useState(0);
  const [media16, setMedia16] = useState(0);

  const [nota1, setNota1] = useState(false);
  const [nota2, setNota2] = useState(false);

  // Novos estados para dados de evolução
  const [dadosEvolucaoEnem, setDadosEvolucaoEnem] = useState({
    labels: [],
    competencia1: [],
    competencia2: [],
    competencia3: [],
    competencia4: [],
    competencia5: []
  });
  
  const [dadosEvolucaoGeral, setDadosEvolucaoGeral] = useState({
    labels: [],
    competencia1: [],
    competencia2: [],
    competencia3: [],
    competencia4: [],
    competencia5: []
  });

  // Novos estados para dados de evolução por dias
  const [dadosEvolucaoPorDias, setDadosEvolucaoPorDias] = useState({
    labels: [],
    competencia1: [],
    competencia2: [],
    competencia3: [],
    competencia4: [],
    competencia5: []
  });

  // Estado para controlar o tipo de visualização do gráfico
  const [tipoVisualizacao, setTipoVisualizacao] = useState('mensal'); // 'mensal' ou 'diario'

  const [mediaFinalEnem, setMediaFinalEnem] = useState({
    competencia1: 0,
    competencia2: 0,
    competencia3: 0,
    competencia4: 0,
    competencia5: 0
  });

  const [mediaFinalGeral, setMediaFinalGeral] = useState({
    competencia1: 0,
    competencia2: 0,
    competencia3: 0,
    competencia4: 0,
    competencia5: 0
  });

  const [alunos, setAlunos] = useState();
  const [idsAlunosUerj, setIdsAlunosUerj] = useState([]);

  // Função para buscar dados de médias e extrair períodos
  function buscarPeriodosDisponiveis(dadosMedias) {
    const periodos = [];

    if (dadosMedias.length > 0) {
      const totalRedacoes = dadosMedias.reduce((total, item) => total + item.quantidade, 0);
      periodos.push({ key: "all", display: "Todos os períodos", ano: null, mes: null, count: totalRedacoes });
    }

    dadosMedias.forEach(item => {
      const [year, month] = item.ano_mes.split("-");
      const key = `${year}-${month.padStart(2, "0")}`;
      periodos.push({
        key,
        display: `${getMonthName(parseInt(month))} ${year}`,
        ano: parseInt(year),
        mes: parseInt(month),
        count: item.quantidade
      });
    });

    if (periodos.length > 1) {
      const ordenados = periodos.slice(1).sort((a, b) => b.key.localeCompare(a.key));
      periodos.splice(1, periodos.length - 1, ...ordenados);
    }

    return periodos;
  }

  useEffect(() => {
    if (!idAluno) return;

    setLoading(true);
    setNota1(false);
    setNota2(false);


    let cancelled = false;

    async function load() {
      setLoadingPeriodos(true);
      setCalculandoMedia(true);

      try {
        const response = await api.get(`/media/${idAluno}`);
        const dados = response.data?.data || [];

        if (cancelled) return;

        setDadosMediasApi(dados);

        const periodos = buscarPeriodosDisponiveis(dados);
        setPeriodosDisponiveis(periodos);

        // seleciona default sem piscar
        setPeriodosSelecionados(periodos.length ? [periodos[0]] : []);

        // se não tem períodos/dados, não tem o que calcular
        if (periodos.length === 0) {
          processarMediasNovo(
          { competencia1: 0, competencia2: 0, competencia3: 0, competencia4: 0, competencia5: 0 },
          false
          );
        }        
      } catch (e) {
        console.error(e);
        toast.error("Erro ao carregar períodos disponíveis");
        if (!cancelled) {
          setDadosMediasApi([]);
          setPeriodosDisponiveis([]);
          setPeriodosSelecionados([]);
          setCalculandoMedia(false);
        }
      } finally {
        if (!cancelled) { 
          setLoadingPeriodos(false);
          setCalculandoMedia(false);
        }
      }
    }

    load();
    carregarMediasUerj(idAluno);

    return () => { cancelled = true; };
  }, [idAluno]);


  async function carregarMediasUerj(alunoId) {

    const reqId = ++uerjReqRef.current;

    setUerjCheckedAlunoId(null);
    setUerjLoading(true);
    setMediaUerj(null);

    try {
      const response = await api.get(`/media-uerj/${alunoId}`);

      if (reqId !== uerjReqRef.current) return;

      const dados = response.data?.data || [];

      if (!dados.length) {
        // Aluno não tem UERJ
        setMediaUerj(null);
        return;
      }

      // Cálculo ponderado
      let somaC1 = 0, somaC2 = 0, somaC3 = 0, somaC4 = 0, somaC5 = 0;
      let total = 0;

      dados.forEach((item) => {
        const q = item.quantidade || 0;
        somaC1 += (item.medias.adequacao_tema || 0) * q;
        somaC2 += (item.medias.tipo_texto || 0) * q;
        somaC3 += (item.medias.argumentacao || 0) * q;
        somaC4 += (item.medias.periodo_coesao || 0) * q;
        somaC5 += (item.medias.modalidade || 0) * q;
        total += q;
      });

      if (!total) {
        setMediaUerj(null);
        return;
      }

      const c1 = Math.round(somaC1 / total);
      const c2 = Math.round(somaC2 / total);
      const c3 = Math.round(somaC3 / total);
      const c4 = Math.round(somaC4 / total);
      const c5 = Math.round(somaC5 / total);
      const mediaGeral = Math.round((c1 + c2 + c3 + c4 + c5) / 5);

      setMediaUerj({
        c1,
        c2,
        c3,
        c4,
        c5,
        mediaGeral,
      });
    } catch (error) {
      console.error("Erro ao carregar médias UERJ:", error);
      if (reqId !== uerjReqRef.current) return;
      // garante reset mesmo se a API der erro
      setMediaUerj(null);
    } finally {
      if (reqId !== uerjReqRef.current) return;
      setUerjLoading(false);
      setUerjCheckedAlunoId(alunoId);
    }
}


  const [provaSelecionada, setProvaSelecionada] = useState("ENEM");


  // Função para obter nome do mês
  function getMonthName(month) {
    const months = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    return months[month - 1];
  }

  // Função para gerenciar seleção múltipla de períodos
  function togglePeriodoSelecionado(periodo) {
    let novosPeriodos = [...periodosSelecionados];
    
    // Se é "Todos os períodos", limpar outros e manter apenas este
    if (periodo.key === 'all') {
      novosPeriodos = [periodo];
    } else {
      // Remover "Todos os períodos" se existir
      novosPeriodos = novosPeriodos.filter(p => p.key !== 'all');
      
      // Verificar se o período já está selecionado
      const index = novosPeriodos.findIndex(p => p.key === periodo.key);
      if (index >= 0) {
        // Remover se já estiver selecionado
        novosPeriodos.splice(index, 1);
      } else {
        // Adicionar se não estiver selecionado
        novosPeriodos.push(periodo);
      }
      
      // Se não há nenhum período selecionado, voltar para "Todos os períodos"
      if (novosPeriodos.length === 0) {
        const todosPeriodos = periodosDisponiveis.find(p => p.key === 'all');
        if (todosPeriodos) {
          novosPeriodos = [todosPeriodos];
        }
      }
    }
    
    setPeriodosSelecionados(novosPeriodos);
  }

  // Função para calcular média de múltiplos períodos
  function calcularMediaPeriodos(periodos, dadosMedias) {
    if (!periodos.length) return;

    let dadosEvolucao = [];
    let mediasGerais = { competencia1: 0, competencia2: 0, competencia3: 0, competencia4: 0, competencia5: 0 };
    let totalQuantidade = 0;

    if (periodos.some(p => p.key === "all")) {
      dadosMedias.forEach(item => {
        const [year, month] = item.ano_mes.split("-");
        const display = `${getMonthName(parseInt(month))} ${year}`;

        dadosEvolucao.push({ periodo: display, medias: item.medias, quantidade: item.quantidade });

        mediasGerais.competencia1 += item.medias.competencia1 * item.quantidade;
        mediasGerais.competencia2 += item.medias.competencia2 * item.quantidade;
        mediasGerais.competencia3 += item.medias.competencia3 * item.quantidade;
        mediasGerais.competencia4 += item.medias.competencia4 * item.quantidade;
        mediasGerais.competencia5 += item.medias.competencia5 * item.quantidade;
        totalQuantidade += item.quantidade;
      });

      setDadosEvolucaoPorDias({ labels: [], competencia1: [], competencia2: [], competencia3: [], competencia4: [], competencia5: [] });
    } else {
      const periodosKeys = periodos.map(p => p.key).filter(k => k !== "all");
      let todasRedacoes = [];

      dadosMedias.forEach(item => {
        const [year, month] = item.ano_mes.split("-");
        const key = `${year}-${month.padStart(2, "0")}`;

        if (periodosKeys.includes(key)) {
          const display = `${getMonthName(parseInt(month))} ${year}`;
          dadosEvolucao.push({ periodo: display, medias: item.medias, quantidade: item.quantidade });

          mediasGerais.competencia1 += item.medias.competencia1 * item.quantidade;
          mediasGerais.competencia2 += item.medias.competencia2 * item.quantidade;
          mediasGerais.competencia3 += item.medias.competencia3 * item.quantidade;
          mediasGerais.competencia4 += item.medias.competencia4 * item.quantidade;
          mediasGerais.competencia5 += item.medias.competencia5 * item.quantidade;
          totalQuantidade += item.quantidade;

          if (item.redacoes) todasRedacoes = todasRedacoes.concat(item.redacoes);
        }
      });

      if (todasRedacoes.length) organizarDadosPorDias(todasRedacoes);
      else setDadosEvolucaoPorDias({ labels: [], competencia1: [], competencia2: [], competencia3: [], competencia4: [], competencia5: [] });
    }

    if (totalQuantidade > 0) {
      mediasGerais.competencia1 = Math.round(mediasGerais.competencia1 / totalQuantidade);
      mediasGerais.competencia2 = Math.round(mediasGerais.competencia2 / totalQuantidade);
      mediasGerais.competencia3 = Math.round(mediasGerais.competencia3 / totalQuantidade);
      mediasGerais.competencia4 = Math.round(mediasGerais.competencia4 / totalQuantidade);
      mediasGerais.competencia5 = Math.round(mediasGerais.competencia5 / totalQuantidade);
    }

    organizarDadosEvolucaoNovo(dadosEvolucao);
    processarMediasNovo(mediasGerais, totalQuantidade > 0);
  }

  

  // Função para calcular média de um período específico
  function calcularMediaPeriodo(redacoes) {
    if (!redacoes || redacoes.length === 0) {
      return {
        competencia1: 0,
        competencia2: 0,
        competencia3: 0,
        competencia4: 0,
        competencia5: 0
      };
    }

    let soma1 = 0, soma2 = 0, soma3 = 0, soma4 = 0, soma5 = 0;
    let count = 0;

    redacoes.forEach(redacao => {
      if (
        redacao.competencia1 != null &&
        redacao.competencia2 != null &&
        redacao.competencia3 != null &&
        redacao.competencia4 != null &&
        redacao.competencia5 != null
      ){
        soma1 += parseInt(redacao.competencia1);
        soma2 += parseInt(redacao.competencia2);
        soma3 += parseInt(redacao.competencia3);
        soma4 += parseInt(redacao.competencia4);
        soma5 += parseInt(redacao.competencia5);
        count++;
      }
    });

    return {
      competencia1: count > 0 ? Math.round(soma1 / count) : 0,
      competencia2: count > 0 ? Math.round(soma2 / count) : 0,
      competencia3: count > 0 ? Math.round(soma3 / count) : 0,
      competencia4: count > 0 ? Math.round(soma4 / count) : 0,
      competencia5: count > 0 ? Math.round(soma5 / count) : 0
    };
  }

  // Função para calcular evolução temporal quando "Todos os períodos" está selecionado
  function calcularEvolucaoTemporal(redacoes) {
    // Agrupar redações por período
    const redacoesPorPeriodo = {};
    
    redacoes.forEach(redacao => {
      try {
        const dateString = redacao.ent || redacao.created_at || '';
        if (dateString) {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const key = `${year}-${month.toString().padStart(2, '0')}`;
          const display = `${getMonthName(month)} ${year}`;
          
          if (!redacoesPorPeriodo[key]) {
            redacoesPorPeriodo[key] = {
              display,
              redacoesTipo0: [],
              redacoesTipo1: []
            };
          }
          
          if (redacao.tipo === 0 || redacao.tipo === "0" || !redacao.tipo) {
            redacoesPorPeriodo[key].redacoesTipo0.push(redacao);
          } else if (redacao.tipo === 1 || redacao.tipo === "1") {
            redacoesPorPeriodo[key].redacoesTipo1.push(redacao);
          }
        }
      } catch (e) {
        // Ignorar erro de parsing
      }
    });

    // Ordenar por período
    const periodosOrdenados = Object.keys(redacoesPorPeriodo).sort();
    
    const dadosEvolucao = [];
    periodosOrdenados.forEach(key => {
      const periodo = redacoesPorPeriodo[key];
      const mediaEnem = calcularMediaPeriodo(periodo.redacoesTipo0);
      const mediaGeral = calcularMediaPeriodo(periodo.redacoesTipo1);
      
      dadosEvolucao.push({
        periodo: periodo.display,
        enem: mediaEnem,
        geral: mediaGeral
      });
    });

    organizarDadosEvolucao(dadosEvolucao);
  }

  // Função para organizar dados de evolução com novo formato
  function organizarDadosEvolucaoNovo(dadosEvolucao) {
    // Ordenar por período
    const dadosOrdenados = dadosEvolucao.sort((a, b) => {
      const [monthA, yearA] = a.periodo.split(' ');
      const [monthB, yearB] = b.periodo.split(' ');

      const dateA = new Date(Number(yearA), getMonthNumber(monthA) - 1);
      const dateB = new Date(Number(yearB), getMonthNumber(monthB) - 1);

      return dateA - dateB;
    });
    
    const labels = dadosOrdenados.map(d => d.periodo);
    
    // Como o novo endpoint não separa por tipo ENEM/Geral, usar os mesmos dados para ambos
    const evolucaoData = {
      labels,
      competencia1: dadosOrdenados.map(d => d.medias.competencia1),
      competencia2: dadosOrdenados.map(d => d.medias.competencia2),
      competencia3: dadosOrdenados.map(d => d.medias.competencia3),
      competencia4: dadosOrdenados.map(d => d.medias.competencia4),
      competencia5: dadosOrdenados.map(d => d.medias.competencia5)
    };
    
    setDadosEvolucaoEnem(evolucaoData);
    setDadosEvolucaoGeral(evolucaoData);
  }
  
  // Função auxiliar para converter nome do mês para número
  function getMonthNumber(monthName) {
    const months = {
      'Janeiro': 1, 'Fevereiro': 2, 'Março': 3, 'Abril': 4, 'Maio': 5, 'Junho': 6,
      'Julho': 7, 'Agosto': 8, 'Setembro': 9, 'Outubro': 10, 'Novembro': 11, 'Dezembro': 12
    };
    return months[monthName] || 1;
  }

  // Função para organizar dados por redação individual
  function organizarDadosPorDias(redacoes) {
    if (!redacoes || redacoes.length === 0) {
      setDadosEvolucaoPorDias({
        labels: [],
        competencia1: [],
        competencia2: [],
        competencia3: [],
        competencia4: [],
        competencia5: []
      });
      return;
    }

    // Ordenar redações por data de criação
    const redacoesOrdenadas = redacoes.sort((a, b) => {
      return new Date(a.created_at) - new Date(b.created_at);
    });
    
    const labels = [];
    const competencia1 = [];
    const competencia2 = [];
    const competencia3 = [];
    const competencia4 = [];
    const competencia5 = [];
    
    redacoesOrdenadas.forEach((redacao, index) => {
      try {
        const date = new Date(redacao.created_at);
        const dia = date.getDate();
        const mes = date.getMonth() + 1;
        const ano = date.getFullYear();
        
        // Label com data completa para identificação única
        labels.push(`${dia}/${mes.toString().padStart(2, '0')}/${ano}`);
        
        // Adicionar notas individuais da redação
        competencia1.push(redacao.c1_nota || 0);
        competencia2.push(redacao.c2_nota || 0);
        competencia3.push(redacao.c3_nota || 0);
        competencia4.push(redacao.c4_nota || 0);
        competencia5.push(redacao.c5_nota || 0);
      } catch (e) {
        console.error('Erro ao processar data da redação:', e);
      }
    });
    
    setDadosEvolucaoPorDias({
      labels,
      competencia1,
      competencia2,
      competencia3,
      competencia4,
      competencia5
    });
  }
  
  // Função para organizar dados de evolução (mantida para compatibilidade)
  function organizarDadosEvolucao(dadosEvolucao) {
    const labels = dadosEvolucao.map(d => d.periodo);
    
    const evolucaoEnem = {
      labels,
      competencia1: dadosEvolucao.map(d => d.enem.competencia1),
      competencia2: dadosEvolucao.map(d => d.enem.competencia2),
      competencia3: dadosEvolucao.map(d => d.enem.competencia3),
      competencia4: dadosEvolucao.map(d => d.enem.competencia4),
      competencia5: dadosEvolucao.map(d => d.enem.competencia5)
    };
    
    const evolucaoGeral = {
      labels,
      competencia1: dadosEvolucao.map(d => d.geral.competencia1),
      competencia2: dadosEvolucao.map(d => d.geral.competencia2),
      competencia3: dadosEvolucao.map(d => d.geral.competencia3),
      competencia4: dadosEvolucao.map(d => d.geral.competencia4),
      competencia5: dadosEvolucao.map(d => d.geral.competencia5)
    };
    
    setDadosEvolucaoEnem(evolucaoEnem);
    setDadosEvolucaoGeral(evolucaoGeral);
  }

  // Função para processar médias com novo formato
  function processarMediasNovo(mediasGerais, temDados) {
    if (temDados) {
      // Definir que há dados disponíveis
      setNota1(true);
      setNota2(true);
      
      // Atualizar médias ENEM (usando as mesmas médias gerais)
      setMedia1(mediasGerais.competencia1);
      setMedia2(mediasGerais.competencia2);
      setMedia3(mediasGerais.competencia3);
      setMedia4(mediasGerais.competencia4);
      setMedia5(mediasGerais.competencia5);
      setMedia6(mediasGerais.competencia1 + mediasGerais.competencia2 + mediasGerais.competencia3 + mediasGerais.competencia4 + mediasGerais.competencia5);
      
      // Atualizar médias Geral (usando as mesmas médias gerais)
      setMedia11(mediasGerais.competencia1);
      setMedia12(mediasGerais.competencia2);
      setMedia13(mediasGerais.competencia3);
      setMedia14(mediasGerais.competencia4);
      setMedia15(mediasGerais.competencia5);
      setMedia16(mediasGerais.competencia1 + mediasGerais.competencia2 + mediasGerais.competencia3 + mediasGerais.competencia4 + mediasGerais.competencia5);
      
      // Atualizar médias finais para os gráficos
      setMediaFinalEnem({
        competencia1: mediasGerais.competencia1,
        competencia2: mediasGerais.competencia2,
        competencia3: mediasGerais.competencia3,
        competencia4: mediasGerais.competencia4,
        competencia5: mediasGerais.competencia5
      });
      
      setMediaFinalGeral({
        competencia1: mediasGerais.competencia1,
        competencia2: mediasGerais.competencia2,
        competencia3: mediasGerais.competencia3,
        competencia4: mediasGerais.competencia4,
        competencia5: mediasGerais.competencia5
      });
    } else {
      // Não há dados disponíveis
      setNota1(false);
      setNota2(false);
      
      // Resetar todas as médias
      setMedia1(0); setMedia2(0); setMedia3(0); setMedia4(0); setMedia5(0); setMedia6(0);
      setMedia11(0); setMedia12(0); setMedia13(0); setMedia14(0); setMedia15(0); setMedia16(0);
      
      setMediaFinalEnem({
        competencia1: 0, competencia2: 0, competencia3: 0, competencia4: 0, competencia5: 0
      });
      
      setMediaFinalGeral({
        competencia1: 0, competencia2: 0, competencia3: 0, competencia4: 0, competencia5: 0
      });
    }

    setLoading(false);
    setCalculandoMedia(false);
  }
  
  // Função para processar e calcular médias (mantida para compatibilidade)
  function processarMedias(redacoesTipo0, redacoesTipo1) {
    // Processar redações tipo 0 (ENEM)
    if (redacoesTipo0.length > 0) {
      setNota1(true);
      let nota1 = 0, nota2 = 0, nota3 = 0, nota4 = 0, nota5 = 0, nota6 = 0;
      let qtd = 0;

      redacoesTipo0.forEach((redacao) => {
        qtd = qtd + 1;
        if (
          redacao.competencia1 != null &&
          redacao.competencia2 != null &&
          redacao.competencia3 != null &&
          redacao.competencia4 != null &&
          redacao.competencia5 != null
        ) {
          nota1 = parseInt(redacao.competencia1) + nota1;
          nota2 = parseInt(redacao.competencia2) + nota2;
          nota3 = parseInt(redacao.competencia3) + nota3;
          nota4 = parseInt(redacao.competencia4) + nota4;
          nota5 = parseInt(redacao.competencia5) + nota5;
          nota6 = parseInt(redacao.competencia1) + parseInt(redacao.competencia2) + parseInt(redacao.competencia3) + parseInt(redacao.competencia4) + parseInt(redacao.competencia5) + nota6;
        }
      });

      if (qtd > 0) {
        const mediaC1 = Math.round(nota1 / qtd);
        const mediaC2 = Math.round(nota2 / qtd);
        const mediaC3 = Math.round(nota3 / qtd);
        const mediaC4 = Math.round(nota4 / qtd);
        const mediaC5 = Math.round(nota5 / qtd);
        
        setMedia1(mediaC1);
        setMedia2(mediaC2);
        setMedia3(mediaC3);
        setMedia4(mediaC4);
        setMedia5(mediaC5);
        setMedia6(Math.round(nota6 / qtd));
        
        // Atualizar média final para o gráfico
        setMediaFinalEnem({
          competencia1: mediaC1,
          competencia2: mediaC2,
          competencia3: mediaC3,
          competencia4: mediaC4,
          competencia5: mediaC5
        });
      }
    } else {
      setNota1(false);
      setMediaFinalEnem({
        competencia1: 0,
        competencia2: 0,
        competencia3: 0,
        competencia4: 0,
        competencia5: 0
      });
    }

    // Processar redações tipo 1 (Geral)
    if (redacoesTipo1.length > 0) {
      setNota2(true);
      let nota1 = 0, nota2 = 0, nota3 = 0, nota4 = 0, nota5 = 0, nota6 = 0;
      let qtd = 0;

      redacoesTipo1.forEach((redacao) => {
        qtd = qtd + 1;
        if (redacao.competencia1 && redacao.competencia2 && redacao.competencia3 && redacao.competencia4 && redacao.competencia5) {
          nota1 = parseInt(redacao.competencia1) + nota1;
          nota2 = parseInt(redacao.competencia2) + nota2;
          nota3 = parseInt(redacao.competencia3) + nota3;
          nota4 = parseInt(redacao.competencia4) + nota4;
          nota5 = parseInt(redacao.competencia5) + nota5;
          nota6 = parseInt(redacao.competencia1) + parseInt(redacao.competencia2) + parseInt(redacao.competencia3) + parseInt(redacao.competencia4) + parseInt(redacao.competencia5) + nota6;
        }
      });

      if (qtd > 0) {
        const mediaC1 = Math.round(nota1 / qtd);
        const mediaC2 = Math.round(nota2 / qtd);
        const mediaC3 = Math.round(nota3 / qtd);
        const mediaC4 = Math.round(nota4 / qtd);
        const mediaC5 = Math.round(nota5 / qtd);
        
        setMedia11(mediaC1);
        setMedia12(mediaC2);
        setMedia13(mediaC3);
        setMedia14(mediaC4);
        setMedia15(mediaC5);
        setMedia16(Math.round(nota6 / qtd));
        
        // Atualizar média final para o gráfico
        setMediaFinalGeral({
          competencia1: mediaC1,
          competencia2: mediaC2,
          competencia3: mediaC3,
          competencia4: mediaC4,
          competencia5: mediaC5
        });
      }
    } else {
      setNota2(false);
      setMediaFinalGeral({
        competencia1: 0,
        competencia2: 0,
        competencia3: 0,
        competencia4: 0,
        competencia5: 0
      });
    }

    setLoading(false);
    setCalculandoMedia(false);
  }

  // Função para limpar seleções
  function limparSelecoes() {
    const todosPeriodos = periodosDisponiveis.find(p => p.key === 'all');
    if (todosPeriodos) {
      setPeriodosSelecionados([todosPeriodos]);
      togglePeriodoSelecionado(todosPeriodos);
    }
    setTipoVisualizacao('mensal');
  }

  async function pegarUser() {
    const data = { id: idAluno };

    try {
      const response = await api.post(`/pegarUser`, data);
      setPessoa(response.data[0].name);
    } catch (error) {
      toast.error("Erro ao carregar aluno");
    }
  }

  useEffect(() => {
    if (!idAluno) return;

    // só atualiza o nome e liga “calculando”
    if (String(idAluno) === String(user.id)) setPessoa(user.nome);
    else pegarUser();

  }, [idAluno, user]);

  const [dadosMediasApi, setDadosMediasApi] = useState([]);

  useEffect(() => {
    async function getAlunos() {
      try {
        const retorno = await api.get(`/usuarios`);

        setAlunos(retorno.data);
        setLoading(false);
      } catch (err) {
        toast.error("Erro ao recuperar alunos!");
      }
    }

    getAlunos();
  }, []);

  useEffect(() => {
    const isAdmin = user?.nivel === "a";
    const isViewingOwnProfile = String(idAluno) === String(user?.id);

    // Só força voltar pro ENEM para NÃO-admin (ou para admin vendo outros perfis)
    const shouldForceBack =
      provaSelecionada === "UERJ" &&
      uerjChecked &&
      !uerjLoading &&
      !hasUerj &&
      !(isAdmin && isViewingOwnProfile);

    if (shouldForceBack) setProvaSelecionada("ENEM");
  }, [provaSelecionada, uerjChecked, uerjLoading, hasUerj, user, idAluno]);



  // useEffect para carregar dados quando os períodos são inicializados
  useEffect(() => {
    if (!periodosSelecionados.length) {
      setCalculandoMedia(false);
      return;
    }

    setCalculandoMedia(true);

    calcularMediaPeriodos(periodosSelecionados, dadosMediasApi);

  }, [periodosSelecionados, dadosMediasApi]);

  // Reset tipo de visualização quando múltiplos períodos são selecionados
  useEffect(() => {
    if (periodosSelecionados.length > 1 || (periodosSelecionados.length === 1 && periodosSelecionados[0].key === 'all')) {
      setTipoVisualizacao('mensal');
    }
  }, [periodosSelecionados]);

  // Forçar visualização mensal se "Todos os períodos" estiver selecionado
  useEffect(() => {
    if (tipoVisualizacao === 'diario' && periodosSelecionados[0]?.key === 'all') {
      setTipoVisualizacao('mensal');
    }
  }, [tipoVisualizacao, periodosSelecionados]);

  return (
    <Template>
      <S.MainWrapper>
        <Container fluid style={{ maxWidth: '95%' }}>
          <S.PageHeader>
            <h1>Análise de Desempenho</h1>
          </S.PageHeader>
          {loading || calculandoMedia ? (
            <Row>
              <Col className="text-center">
                <div className="shadow p-3 mb-4 bg-white rounded fdark flex-c">
                  <div>
                    <div className="spinner-grow text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-secondary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-success" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-danger" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-warning" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-info" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                  <div>
                     <strong>{calculandoMedia ? 'CALCULANDO MÉDIAS' : 'CARREGANDO'}</strong>
                   </div>
                 </div>
               </Col>
             </Row>
          ) : (
            <>
              {media && (
                <>
                  <Row>
                    <Col>
                      <S.StatsCard>
                        <div className="stats-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          {/* ESQUERDA - TÍTULO */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <i className="fas fa-chart-line" style={{color: '#007BC6', fontSize: '1.5rem'}}></i>
                            <h4 style={{ margin: 0 }}>
                              Média final de {pessoa}
                              {periodosSelecionados.length === 1 
                                ? ` - ${periodosSelecionados[0].display}`
                                : periodosSelecionados.length > 1 
                                  ? ` - ${periodosSelecionados.length} períodos selecionados`
                                  : ' - Nenhum período selecionado'
                              }
                            </h4>
                          </div>
                          {/* DIREITA - BOTÕES ENEM / UERJ */}
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button
                              onClick={() => setProvaSelecionada("ENEM")}
                              style={{
                                padding: "6px 14px",
                                borderRadius: "8px",
                                border: "1px solid #007BC6",
                                background: provaSelecionada === "ENEM" ? "#007BC6" : "white",
                                color: provaSelecionada === "ENEM" ? "white" : "#007BC6",
                                fontWeight: 600,
                                cursor: "pointer"
                              }}
                            >
                              ENEM
                            </button>

                            {showUerjButton && (
                              <button
                                onClick={() => setProvaSelecionada("UERJ")}
                                style={{
                                  padding: "6px 14px",
                                  borderRadius: "8px",
                                  border: "1px solid #007BC6",
                                  background: provaSelecionada === "UERJ" ? "#007BC6" : "white",
                                  color: provaSelecionada === "UERJ" ? "white" : "#007BC6",
                                  fontWeight: 600,
                                  cursor: "pointer"
                                }}
                              >
                                UERJ
                              </button>
                            )}
                          </div>
                        </div>
                        <Row>
                          <Col md={2} className="text-center">
                            <div className="stats-value">
                              {provaSelecionada === "ENEM" ? Math.round(media1) : mediaUerj?.c1 ?? 0}
                            </div>
                            <div className="stats-label">Competência 1</div>
                          </Col>
                          <Col md={2} className="text-center">
                            <div className="stats-value">
                              {provaSelecionada === "ENEM" ? Math.round(media2) : mediaUerj?.c2 ?? 0}
                            </div>
                            <div className="stats-label">Competência 2</div>
                          </Col>
                          <Col md={2} className="text-center">
                            <div className="stats-value">
                              {provaSelecionada === "ENEM" ? Math.round(media3) : mediaUerj?.c3 ?? 0}
                            </div>
                            <div className="stats-label">Competência 3</div>
                          </Col>
                          <Col md={2} className="text-center">
                            <div className="stats-value">
                              {provaSelecionada === "ENEM" ? Math.round(media4) : mediaUerj?.c4 ?? 0}
                            </div>
                            <div className="stats-label">Competência 4</div>
                          </Col>
                          <Col md={2} className="text-center">
                            <div className="stats-value">
                              {provaSelecionada === "ENEM" ? Math.round(media5) : mediaUerj?.c5 ?? 0}
                            </div>
                            <div className="stats-label">Competência 5</div>
                          </Col>
                          <Col md={2} className="text-center">
                            <div className="stats-value">
                              {provaSelecionada === "ENEM" ? Math.round((media1 + media2 + media3 + media4 + media5) / 5) : mediaUerj?.mediaGeral ?? 0}
                            </div>
                            <div className="stats-label">Média Geral</div>
                          </Col>
                        </Row>
                      </S.StatsCard>
                    </Col>
                  </Row>

                  {/* Filtro de seleção de aluno */}
                  {user.nivel === "a" && (
                    <Row>
                      <Col>
                        <S.FilterSection>
                          <label className="form-label d-flex align-items-center gap-2 mb-3">
                            <i className="fas fa-user-graduate" style={{color: '#007BC6', marginRight: '10px'}}></i>
                            <strong>Selecionar Aluno:</strong>
                          </label>
                          <select
                            onChange={(e) => setIdAluno(e.target.value)}
                            className="form-control"
                            value={idAluno}
                            style={{maxWidth: '500px', width: '100%', height: '45px', fontSize: '14px', border: '1px solid #ccc'}}
                          >
                            <option value={user.id}>Meu perfil</option>
                            {alunos &&
                              alunos.map((aluno, index) => (
                                <option key={index} value={aluno.id}>
                                  {aluno.name}
                                </option>
                            ))}
                          </select>
                        </S.FilterSection>
                      </Col>
                    </Row>
                  )}

                  {/* Filtros */}
                  <Row>
                    <Col>
                      <S.FilterSection>
                        <div className="filter-row">
                        {/* Períodos disponíveis */}
                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <label className="form-label mb-0">
                                Selecionar Períodos:
                                <small className="text-muted d-block">
                                  Clique para selecionar múltiplos períodos e comparar médias
                                </small>
                              </label>
                              {periodosSelecionados.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-secondary"
                                  onClick={limparSelecoes}
                                >
                                  <i className="fa fa-times"></i> Limpar ({periodosSelecionados.length})
                                </button>
                              )}
                            </div>
                          
                          {loadingPeriodos ? (
                            <div className="text-center">
                              <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Carregando períodos...</span>
                              </div>
                            </div>
                          ) : periodosDisponiveis.length > 0 ? (
                            <div>
                              <div className={`d-flex flex-wrap gap-4 ${
                                periodosDisponiveis.length <= 3 ? 'justify-content-start' : ''
                              }`}>
                                {periodosDisponiveis.map((periodo, index) => {
                                  const isSelected = periodosSelecionados.some(p => p.key === periodo.key);
                                  return (
                                    <div 
                                      key={index} 
                                      className={`flex-grow-1 mb-2 ${
                                        periodosDisponiveis.length <= 3 
                                          ? 'flex-grow-0' 
                                          : periodosDisponiveis.length <= 6 
                                            ? 'col-md-4 col-sm-6' 
                                            : 'col-lg-3 col-md-4 col-sm-6'
                                      }`}
                                      style={{
                                        minWidth: periodosDisponiveis.length <= 3 ? '200px' : 'auto',
                                        maxWidth: periodosDisponiveis.length <= 3 ? '250px' : 'auto',
                                        marginRight: '20px',
                                        marginBottom: '10px'
                                      }}
                                    >
                                      <div 
                                        className={`border rounded p-2 h-100 ${
                                          isSelected 
                                            ? 'border-primary bg-primary text-white' 
                                            : hoveredPeriodo === periodo.key 
                                              ? 'border-primary bg-light' 
                                              : 'border-secondary'
                                        }`}
                                        onClick={() => togglePeriodoSelecionado(periodo)}
                                        onMouseEnter={() => setHoveredPeriodo(periodo.key)}
                                        onMouseLeave={() => setHoveredPeriodo(null)}
                                        style={{ 
                                          cursor: 'pointer',
                                          transition: 'all 0.2s ease'
                                        }}
                                      >
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={isSelected}
                                            readOnly
                                          />
                                          <label className="form-check-label">
                                            <div>
                                              <strong>{periodo.display}</strong>
                                            </div>
                                            <small className={isSelected ? "text-white-50" : "text-muted"}>
                                              {periodo.count} {periodo.count > 1 ? 'redações' : 'redação'}
                                            </small>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                              
                              {periodosSelecionados.length > 0 && (
                                <div className="mt-3 p-3 bg-light rounded">
                                  <small className="text-muted">
                                    <strong>Períodos selecionados:</strong>
                                    <br />
                                    {periodosSelecionados.map((periodo, index) => (
                                      <span key={index}>
                                        {periodo.display}
                                        {index < periodosSelecionados.length - 1 ? ', ' : ''}
                                      </span>
                                    ))}
                                  </small>
                                  <br />
                                  <small className="text-dark">
                                    <i className="fa fa-info-circle text-info"></i> {' '}
                                    {periodosSelecionados.length === 1 
                                      ? 'Mostrando média do período selecionado'
                                      : `Mostrando média combinada de ${periodosSelecionados.length} períodos`}
                                  </small>
                                </div>
                              )}  
                            </div>
                          ) : (
                            <div className="alert alert-info">
                              <i className="fa fa-info-circle"></i> Nenhuma redação corrigida encontrada para este aluno.
                            </div>
                          )}
                        </div>

                        </div>
                      </S.FilterSection>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <S.StatsCard>
                        <div className="stats-header">
                          <i className="fas fa-info-circle" style={{color: '#007BC6', fontSize: '1.3rem'}}></i>
                          <h4>Informações sobre as Competências</h4>
                        </div>
                        <p className="mb-3" style={{color: '#666', fontSize: '1.1rem'}}>
                          Cada competência tem o valor máximo de <strong>200 pontos</strong>.
                          Abaixo você poderá ver sua evolução e média de pontos em cada competência.
                        </p>
                        {periodosSelecionados.length > 1 && (
                          <div className="mt-2 p-3" style={{background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)', borderRadius: '12px', border: '1px solid rgba(102, 126, 234, 0.2)'}}>
                            <small style={{color: '#333', fontWeight: '500'}}>
                              <i className="fa fa-info-circle" style={{color: '#667eea'}}></i> {' '}
                              Os gráficos mostram a média combinada de <strong>{periodosSelecionados.length} períodos selecionados</strong>.
                            </small>
                          </div>
                        )}
                      </S.StatsCard>
                       {/* Filtro de tipo de visualização */}
                        {periodosDisponiveis.length > 1 && (
                          <S.FilterSection>
                            <label className="form-label d-flex align-items-center gap-2 mb-3">
                              <i className="fas fa-chart-bar" style={{color: '#007BC6', marginRight: '10px'}}></i>
                              <strong>Tipo de Visualização:</strong>
                            </label>
                            <div className="d-flex gap-5">
                              <div className="form-check" style={{marginRight: '40px'}}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="tipoVisualizacao"
                                  id="mensal"
                                  value="mensal"
                                  checked={tipoVisualizacao === 'mensal'}
                                  onChange={(e) => setTipoVisualizacao(e.target.value)}
                                  style={{accentColor: '#007BC6'}}
                                />
                                <label className="form-check-label" htmlFor="mensal" style={{fontWeight: '500', color: '#333'}}>
                                  Mensal
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="tipoVisualizacao"
                                  id="diario"
                                  value="diario"
                                  checked={tipoVisualizacao === 'diario'}
                                  onChange={(e) => setTipoVisualizacao(e.target.value)}
                                  disabled={periodosSelecionados[0]?.key === 'all'}
                                  style={{accentColor: '#007BC6'}}
                                />
                                {/* adiciona um gap entre os radio buttons */}
                                <label className="form-check-label" htmlFor="diario" style={{fontWeight: '500', color: periodosSelecionados[0]?.key === 'all' ? '#999' : '#333'}}>
                                  {periodosSelecionados[0]?.key === 'all'
                                    ? 'Diário (Selecione períodos específicos)'
                                    : 'Diário'
                                  }
                                </label>
                              </div>
                            </div>
                          </S.FilterSection>
                        )}
                    </Col>
                  </Row>
                  <Row className="justify-content-center">
                    {(nota1 || nota2) && (
                          <Col xs={12} lg={10} xl={8}>
                            <legend className="text-center">
                              {tipoVisualizacao === 'mensal'
                                ? 'Minha média'
                                : periodosSelecionados.length === 1
                                  ? `Evolução por redação - ${periodosSelecionados[0]?.display || ''}`
                                  : `Evolução por redação - ${periodosSelecionados.length} períodos`
                              }
                              {periodosSelecionados.length > 1 && (
                                <small className="text-muted">
                                  {tipoVisualizacao === 'mensal' ? ' (Média combinada)' : ' (Redações individuais)'}
                                </small>
                              )}
                            </legend>
                            <S.ChartContainer>
                              {tipoVisualizacao === 'mensal' ? (
                                <GraficoLinhas
                                  dadosEvolucao={dadosEvolucaoEnem}
                                  mediaFinal={mediaFinalEnem}
                                />
                              ) : (
                                dadosEvolucaoPorDias.labels.length > 0 ? (
                                  <GraficoLinhas2
                                    dadosEvolucao={dadosEvolucaoPorDias}
                                    mediaFinal={mediaFinalEnem}
                                  />
                                ) : (
                                  <div className="text-center text-muted p-4">
                                    <i className="fa fa-info-circle"></i>
                                    <p className="mb-0">Nenhum dado disponível para visualização por dias neste período.</p>
                                  </div>
                                )
                              )}
                            </S.ChartContainer>
                          </Col>
                        )}
                  </Row>


                </>
              )}
            </>
          )}
        </Container>
      </S.MainWrapper>
    </Template>
  );
}

export default Medias;